import { BaseUseCase } from "@domains/useCases/UseCaseBase";
export default class DownloadPDFReport extends BaseUseCase {
    constructor(downloadRepo) {
        super();
        this.downloadRepo = downloadRepo;
    }
    fetchResult(data) {
        return this.downloadRepo.donwloadPdf(data);
    }
}
